module.exports = __webpack_public_path__ + "media/a_todos_um_bom_natal.e2e1bf9b.mp3";